import { render, staticRenderFns } from "./folder-header.vue?vue&type=template&id=137e2e1a&scoped=true&"
import script from "./folder-header.vue?vue&type=script&lang=js&"
export * from "./folder-header.vue?vue&type=script&lang=js&"
import style0 from "./folder-header.vue?vue&type=style&index=0&id=137e2e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e2e1a",
  null
  
)

export default component.exports